import BaseComponent from '../BaseComponent';
import { ClassNames } from '../../utils/dom/css-classes';
import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import { GEOLOCATION_CHANGE_EVENT } from '../LocationSearch/LocationSearch';
import Manipulator from '../../utils/dom/manipulator';
import dataLayer from '../../utils/data-layer';

const NAME = 'CourtSearch';

class CourtSearch extends BaseComponent {
	constructor(element) {
		super(element);
		this.state = {
			findClickCount: 0
		}
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		const submitButton = SelectorEngine.findOne('.lta-court-booking__find-court', this._element);
		const locationComponent = SelectorEngine.findOne('.js-lta-location-search', this._element);
		const dateComponent = SelectorEngine.findOne('.js-datepicker', this._element);
		const clearDateButton = SelectorEngine.findOne('.lta-datepicker__clear-icon', this._element);
		const latInput = SelectorEngine.findOne('.js-location-lat-field-input', this._element);
		const lonInput = SelectorEngine.findOne('.js-location-lon-field-input', this._element);
		const locationInput = SelectorEngine.findOne('.js-location-search-field-input', this._element);
		const datePicker = SelectorEngine.findOne('duet-date-picker', this._element);
		const calendarIcon = SelectorEngine.findOne('.lta-datepicker__calendar-icon', this._element);

		const strictSearch = Manipulator.getDataAttribute(locationComponent, 'strictSearch');

		EventHandler.on(clearDateButton, 'click', () => {
			dateComponent.value = '';
			datePicker.value = '';
			clearDateButton.classList.add(ClassNames.Hidden);
			calendarIcon.classList.remove(ClassNames.Hidden);
		});

		EventHandler.on(locationInput, 'input', () => {
			latInput.value = '';
			lonInput.value = '';

			locationComponent.classList.remove(ClassNames.Invalid);
			submitButton.disabled = false;
		});

		EventHandler.on(locationInput, GEOLOCATION_CHANGE_EVENT, (event) => {
			latInput.value = event.lat;
			lonInput.value = event.lng;
		});

		EventHandler.on(submitButton, 'click', () => {
			const triggerDataLayer = Manipulator.getDataAttribute(submitButton, 'trigger-first-time');
			const shouldTrigger = (location.origin + location.pathname !== sessionStorage.getItem("url"));
			if(shouldTrigger && sessionStorage.getItem("url")) {
				sessionStorage.removeItem("url");
			}
			const formData = new FormData(this._element);
			const data = [...formData.entries()];

			if(triggerDataLayer && shouldTrigger) {
				try {
					dataLayer.push({event: triggerDataLayer});
					sessionStorage.setItem("url", location.origin + location.pathname);
				} catch (error) {
					console.log(error.message);
				}
			}

			const [, locationValue] = data.find(([field]) => field === 'location');
			const [, latitude] = data.find(([field]) => field === 'latitude');
			const [, longitude] = data.find(([field]) => field === 'longitude');
			const dateData = data.find(([field]) => field === 'date');

			locationComponent.classList.remove(ClassNames.Invalid);
			dateComponent && dateComponent.classList.remove(ClassNames.Invalid);

			const isInvalidLocation = !locationValue;
			const isInvalidLatLong = !(latitude && longitude);

			if (isInvalidLocation || (strictSearch && isInvalidLatLong)) {
				locationComponent.classList.add(ClassNames.Invalid);
				return;
			}
			if (!!dateData) {
				const [, dateValue] = dateData;
				if (!(new Date(dateValue) instanceof Date)) {
					dateComponent.classList.add(ClassNames.Invalid);
				}
			}

			this._element.submit();
		});
	}
}

export default CourtSearch;
